import { useContext, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { UBAppModal } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import TabAutoComplete from "../../../../Libraries/TabAutoComplete";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import styles from "./styles.modules.css";

const languageList = [
  { label: "English", value: "en" },
  { label: "اردو", value: "ur" },
  { label: "Roman urdu", value: "romn" },
];

const ChangeLanguageModal = ({ open, onClose, onConfirm, loading, value }) => {
  const [languageCode, setLanguageCode] = useState(value || "");
  const [I18n] = useContext(LanguageContext);

  const selectedLabel =
    languageList.find((l) => l.value === languageCode)?.label || "";

  useEffect(() => {
    if (open) setLanguageCode(value || "");
  }, [open]);

  return (
    <UBAppModal
      id="change_language_modal"
      open={open}
      header={{
        title: "language",
        handleClose: onClose,
        dont_show_cross_icon: true,
      }}
      className={`${styles.changeCategoryModal} changeCategoryModal`}
      footer={[
        {
          data: {
            className: "ubSecondaryButton",
            title: I18n.cancel,
            onClick: onClose,
            id: `ChangeLanguageModal_cancel`,
          },
        },
        {
          data: {
            className: "ubPrimaryButton fontSize12 fontWeight400 bgPrimary",
            title: I18n.save,
            onClick: () => onConfirm(languageCode),
            disabled: !Boolean(languageCode) || loading,
            loading,
            id: `ChangeLanguageModal_confirm`,
          },
        },
      ]}
    >
      <Box>
        <TabAutoComplete
          className={styles.dropdownContainer}
          id={"ChangeLanguageModal_category"}
          list={languageList}
          label={I18n.select_language}
          handleSelect={(item) => setLanguageCode(item?.value || "")}
          value={selectedLabel}
          asCreate="language"
          placeholder={I18n.select_language}
          handleStartLogEvent={() =>
            triggerLogEvent(analytics, "change_language")
          }
        />
      </Box>
    </UBAppModal>
  );
};

export default ChangeLanguageModal;
